module.exports = "pegasus/assets/blocks/column-13-theme6.png";